import Layout from "@/components/layout/Layout";

const tools = [
  {
    name: "Cursor",
    type: "IDE / עורך קוד",
    description: "סביבת פיתוח המבוססת על VS Code שנבנתה מחדש סביב בינה מלאכותית. מאפשרת כתיבת קוד ושינוי מבנה פרויקט שלם בשיחה חופשית. החל מיוני 2025, הכלי עבר למודל תמחור המבוסס על צריכת קרדיטים ושימוש בפועל.",
    target: "מפתחים מקצועיים המעוניינים להכפיל את הפרודוקטיביות שלהם.",
    pros: "הבנה עמוקה של הקשר הפרויקט, חיזוי קוד מדויק.",
    pricing: "חינם לשימוש בסיסי, Pro מ-$20/חודש (מבוסס קרדיטים + שימוש), Teams $40/משתמש/חודש.",
    url: "https://cursor.com"
  },
  {
    name: "Claude Code",
    type: "סביבת פיתוח אג'נטית",
    description: "נחשב לכלי הקידוד המוביל בשוק נכון לינואר 2026. הכלי התפתח מעבר לממשק שורת פקודה (CLI) וכיום זמין כתוסף ל-VS Code, JetBrains, אפליקציית דסקטופ ייעודית וסביבת IDE מלאה בדפדפן. מסוגל להריץ טסטים ולבצע שינויים אוטונומיים.",
    target: "מפתחי Full-stack המחפשים אוטומיזציה מלאה של תהליכי פיתוח.",
    pros: "יכולות לוגיות גבוהות ביותר, ביצוע משימות מקצה לקצה.",
    pricing: "כלול במנוי Claude Max ($100/חודש) או Team ($30/משתמש), ניתן גם דרך API לפי צריכת טוקנים.",
    url: "https://claude.ai/code"
  },
  {
    name: "Bolt (StackBlitz)",
    type: "בניית אפליקציות",
    description: "פלטפורמה להקמת אפליקציות Full-stack מלאות בתוך הדפדפן מפרומפט טקסטואלי. המערכת מגדירה שרתים, מתקינה ספריות ופורסת את האפליקציה בתוך שניות. המודל העסקי מבוסס על הקצאת טוקנים חודשית.",
    target: "יזמים ומפתחים המעוניינים להקים אב-טיפוס (MVP) מהיר.",
    pros: "מהירות הקמה חסרת תקדים, סביבת עבודה מוכנה בתוך הדפדפן.",
    pricing: "חינם עם 1M טוקנים/חודש, Pro $25/חודש עם 10M טוקנים, Teams $30/משתמש/חודש.",
    url: "https://bolt.new"
  },
  {
    name: "v0 (Vercel)",
    type: "יצירת UI / ממשקים",
    description: "מנוע יצירת ממשקי משתמש המבוסס על Tailwind CSS ו-React. מתמקד בעיצוב ובניית ה-Frontend בלבד — המערכת אינה יוצרת Backend, APIs או בסיסי נתונים. מצטיין בהפיכת תיאור טקסטואלי לקוד נקי ונגיש.",
    target: "מעצבים ומפתחי Frontend המתמקדים בחוויית משתמש.",
    pros: "קוד UI איכותי ומוכן להטמעה, הבנה עיצובית גבוהה.",
    pricing: "מודל קרדיטים חינמי, מנויים בתשלום לשימוש נרחב.",
    url: "https://v0.dev"
  },
  {
    name: "Replit Agent",
    type: "פיתוח אג'נטי אוטונומי",
    description: "ה-Agent הנוכחי (גרסה 3) מציע יכולות חשיבה מורחבות ופעולה אוטונומית מלאה. המערכת מנהלת את כל תהליך הפיתוח מבניית ה-DB ועד פריסת הענן. התמחור מבוסס על 'רמת המאמץ' (Effort-based) הנדרשת מהמודל.",
    target: "אנשים ללא רקע טכני עמוק או מפתחים המעוניינים בסוכן עצמאי.",
    pros: "ניהול עצמאי של Deployment, פשטות מקסימלית.",
    pricing: "Starter חינמי, Core $25/חודש ($25 קרדיטים כלולים), Pro חדש $100/חודש לצוותים.",
    url: "https://replit.com"
  },
  {
    name: "Lovable",
    type: "Full-stack AI App Builder",
    description: "פלטפורמה מתקדמת לבניית אפליקציות מורכבות באמצעות שיחה, המאפשרת שליטה מלאה בקוד. Lovable משתמש במודל Gemini 3 Flash כמודל ברירת מחדל לביצועים מהירים. התמחור מבוסס על קרדיטים לשינויי קוד.",
    target: "סטארט-אפים ויוצרי מערכות המחפשים מהירות של No-code עם גמישות של קוד.",
    pros: "אינטגרציה מעולה עם Supabase, גמישות פיתוח גבוהה.",
    pricing: "חינם עם 5 קרדיטים/יום, Pro $25/חודש (100 קרדיטים), Business $50/חודש.",
    url: "https://lovable.dev"
  }
];

const AIDevTools = () => {
  return (
    <Layout>
      <div className="bg-white min-h-screen pt-32 pb-20">
        <div className="container mx-auto px-6 max-w-4xl">
          <header className="mb-20 text-right">
            <p className="text-xs font-bold tracking-widest text-slate-400 uppercase mb-3">פיתוח ובנייה</p>
            <h1 className="text-4xl font-black text-slate-900 tracking-tight mb-4">כלי AI לבניית מערכות</h1>
            <p className="text-lg text-slate-500 leading-relaxed max-w-2xl font-light">
              סקירת הדור הבא של כלי הפיתוח המאפשרים לבנות מערכות מורכבות במהירות ובדיוק חסר תקדים. נכון לפברואר 2026.
            </p>
          </header>

          <div className="grid md:grid-cols-2 gap-x-12 gap-y-16">
            {tools.map((tool, idx) => (
              <div key={idx} className="space-y-4 border-t border-slate-100 pt-8">
                <div className="flex justify-between items-baseline">
                  <h3 className="text-xl font-bold text-slate-900">{tool.name}</h3>
                  <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">{tool.type}</span>
                </div>
                
                <p className="text-sm text-slate-600 leading-relaxed">
                  {tool.description}
                </p>
                
                <div className="space-y-3 pt-2">
                  <div>
                    <span className="text-[10px] font-bold text-slate-900 uppercase block mb-1">למי מתאים</span>
                    <p className="text-xs text-slate-500">{tool.target}</p>
                  </div>
                  <div>
                    <span className="text-[10px] font-bold text-slate-900 uppercase block mb-1">מחירון בסיסי</span>
                    <p className="text-xs text-slate-500 font-medium">{tool.pricing}</p>
                  </div>
                </div>

                <a 
                  href={tool.url} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-block text-[10px] font-bold text-blue-600 uppercase tracking-widest pt-2 hover:underline"
                >
                  מעבר לאתר
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AIDevTools;